import "jquery.marquee";
import { Fancybox } from "@fancyapps/ui";
import { tns } from "tiny-slider/src/tiny-slider";
import LazyLoad from "vanilla-lazyload";


jQuery(function() {
    var lazyLoad = new LazyLoad();

    // Init Galerie
    Fancybox.bind("[data-fancybox='galerie']", {
        // Your options go here
        thumbs: {
        autoStart: true,
        },
    });

    const elementIsOnScreen = (element) => {
        if (jQuery(element).length != 0) {

            let elementTop = jQuery(element).offset().top
            let elementBottom = jQuery(element).outerHeight() + elementTop
    
            let viewportTop = jQuery(window).scrollTop();
            let viewportBottom = jQuery(window).height() + viewportTop
    
            return elementBottom > viewportTop && elementTop < viewportBottom
        } else {
            return false
        }
    }


    const updatePostDialogChosenHome = () => {

        jQuery('.post-dialog').on('mouseenter', function () {
            const post_id = jQuery(this).data('id')
            jQuery('.active-thumb').removeClass('active-thumb')
            jQuery('.active-text').removeClass('active-text')
            jQuery(`.thumb-post-${post_id}`).addClass('active-thumb')
            jQuery(this).addClass('active-text')
        })
    }

    updatePostDialogChosenHome();



    const displaySubmenu = () => {
        jQuery('.item-primary-menu').on('click', function() {
            const item_id = jQuery(this).data('id');

            jQuery('.item-submenu').not(jQuery(`#child-parent-${item_id}`)).addClass('hidden')
            jQuery('.item-submenu').removeClass('flex')

            jQuery('.item-primary-menu').not(jQuery(this)).removeClass('active-primary-menu-item')

            jQuery(`#child-parent-${item_id}`).toggleClass('hidden')
            jQuery(`#child-parent-${item_id}`).addClass('flex')

            if (jQuery(`#child-parent-${item_id}`).hasClass('hidden')) {
                jQuery('.background-opacity-menu').addClass('hidden')
            } else {
                jQuery('.background-opacity-menu').removeClass('hidden')
            }

            if (jQuery(this).hasClass('active-primary-menu-item')) {
                const url = jQuery(this).data('link')
                window.location = url
            } else {
                jQuery(this).addClass('active-primary-menu-item')
            }
        })
    }

    const hideMenu = () => {
        jQuery('.background-opacity-menu').on('click', function() {
            jQuery('.background-opacity-menu').toggleClass('hidden')
            jQuery('.item-primary-menu').removeClass('active-primary-menu-item')
            jQuery('.item-submenu').removeClass('flex')
            jQuery('.item-submenu').addClass('hidden')
        })
    }

    hideMenu();
    // displaySubmenu();

    const displayThumbnailFromSubmenu = () => {
        jQuery('.submenu-item-link').on('mouseenter', function() {
            const item_id = jQuery(this).data('id')

            jQuery('.thumbnail-childs').removeClass('z-50')
            jQuery('.thumbnail-childs').addClass('z-10')
            jQuery(`#thumbnail-child-${item_id}`).removeClass('z-10')
            jQuery(`#thumbnail-child-${item_id}`).addClass('z-50')
        })

        jQuery('.item-primary-menu').on('mouseenter', function() {
            jQuery('.thumbnail-childs').removeClass('z-50')
            jQuery('.thumbnail-childs').addClass('z-10')
        })
    }

    displayThumbnailFromSubmenu();


    const fastContactFixed = () => {
        const containerFastContact = jQuery('#container-fast-contact')
        const distanceFromTop = containerFastContact.offset().top
        
        function checkAndFixElementPosition() {
            if (jQuery(window).scrollTop() >= distanceFromTop) {
                containerFastContact.addClass('fixed');
                containerFastContact.removeClass('absolute');
            } else {
                containerFastContact.addClass('absolute');
                containerFastContact.removeClass('fixed');
            }
        }

        checkAndFixElementPosition()
        jQuery(window).scroll(checkAndFixElementPosition);
    }

    if (jQuery('#container-fast-contact').length != 0) {
        fastContactFixed()
    }

    const sliderReferences = () => {

        jQuery('.slider-references').marquee({
            duration: 10000,
            gap: 50,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            startVisible: true
        });
        jQuery('.slider-references-responsive').marquee({
            duration: 10000,
            gap: 50,
            delayBeforeStart: 0,
            direction: 'right',
            duplicated: true,
            startVisible: true
        });
    }

    if (jQuery('.slider-references').length != 0) {
        sliderReferences();
    }



    const displayMenuResponsive = () => {
        jQuery('#header-burger').on('click', function() {
            jQuery('#menu-responsive').addClass('menu-responsive-active')
        })
    }

    const hideMenuResponsive = () => {
        jQuery('#close-menu-responsive').on('click', function() {
            jQuery('#menu-responsive').removeClass('menu-responsive-active')
        })
    }

    displayMenuResponsive();
    hideMenuResponsive();


    if (jQuery('#slider-encart-responsive').length > 0) {
        let sliderEncartHeader = tns({
            container: "#slider-encart-responsive",
            items: 1,
            loop: false,
            mouseDrag: true,
            nav: false,
            swipeAngle: false,
            controlsContainer: "#controls-encart-responsive",
        })
    }

    jQuery(document).on("click", 'a[href^="#"]', function (event) {
        event.preventDefault();
        jQuery("html, body").animate(
          {
            scrollTop: jQuery(jQuery.attr(this, "href")).offset().top - 50,
          },
          600
        );
    });

    const displayMenuOnScrollPhone = () => {
        let lastScrollTop = 0;

        jQuery(window).on('scroll', function(event) {
            let currrentPosScroll = jQuery(this).scrollTop();
            if (currrentPosScroll > lastScrollTop & currrentPosScroll > 200) {
                jQuery("#header-top").addClass('h-0 overflow-hidden')
                jQuery('#header-top').removeClass('h-32')
            } else {
                jQuery("#header-top").removeClass('h-0 overflow-hidden')
                jQuery('#header-top').addClass('h-32')
            }
            lastScrollTop = currrentPosScroll
        })
    }
    if (jQuery(window).width() < 1280 ) {
        displayMenuOnScrollPhone();
    }

    const buttonEncartContactDisplaying = () => {
        jQuery('#btn-fast-contact').on('click', function() {
            jQuery('#container-fast-contact').toggleClass('container-fc-active')
            jQuery('#container-fast-contact-responsive').toggleClass('z-[9999] opacity-1 z-0 opacity-0 h-0')
        })
        jQuery('#container-fast-contact').on('mouseenter', function() {
            jQuery(this).addClass('container-fc-active')
        }).on('mouseleave', function() {
            jQuery(this).removeClass('container-fc-active')
        })

        
    }
    buttonEncartContactDisplaying();

    const apparitionFunction = () => {
            let scrolledFromTop = jQuery(window).scrollTop()
            let windowHeight = jQuery(window).height();

            let maxHeight = scrolledFromTop + windowHeight

            if (scrolledFromTop >= 360) {
                jQuery('#btn-scroll-top').removeClass('opacity-0')
                if (jQuery(window).width() < 1440) {
                    jQuery('#btn-fast-contact').removeClass('opacity-0')
                } else {
                    if (elementIsOnScreen('#container-fast-contact') == true ) {
                        jQuery('#btn-fast-contact').removeClass('opacity-0')
                    } else {
                        jQuery('#btn-fast-contact').addClass('opacity-0')
                    }
                }
            } else {
                jQuery('#btn-scroll-top, #btn-fast-contact').addClass('opacity-0')
            }

            jQuery('.appear').each(function() {
                let distance_from_top = jQuery(this).offset().top;

                if (maxHeight >= distance_from_top + 100) {
                    jQuery(this).animate({
                        top: 0,
                        opacity: 1
                    })
                }
            })
    }

    jQuery(window).on('scroll', function() {
        apparitionFunction();
    })

    apparitionFunction();


    // jQuery('.animsition').animsition({
    //     inClass: 'fade-in-right',
    //     outClass: 'fade-out-left',
    //     inDuration: 1500,
    //     outDuration: 800,
    //     linkElement: '.animsition-link',
    //     // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
    //     loading: true,
    //     loadingParentElement: 'body', //animsition wrapper element
    //     loadingClass: 'animsition-loading',
    //     loadingInner: '', // e.g '<img src="loading.svg" />'
    //     timeout: false,
    //     timeoutCountdown: 5000,
    //     onLoadEvent: true,
    //     browser: [ 'animation-duration', '-webkit-animation-duration'],
    //     // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
    //     // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
    //     overlay : false,
    //     overlayClass : 'animsition-overlay-slide',
    //     overlayParentElement : 'body',
    //     transition: function(url){ window.location.href = url; }
    // })


    const ajaxActualities = () => {

        let page = 2

        let ajax_load_actualities = (page) => {

            jQuery.ajax({
                url: "/wp/wp-admin/admin-ajax.php",
                type: "POST",
                data: {
                    action: "load_more_actualities",
                    page: page
                },
                success: function(data) {
                    jQuery('#container-actualities-list').append(data)
                    var lazyLoad = new LazyLoad();
                }
            })
        }

        jQuery("#button-more-actualities").on("click", function() {

            ajax_load_actualities(page)
            page = page + 1;
            
        })
    }

    if (jQuery("#list-actualities").length != 0) ajaxActualities();


    const timeline_evolution = () => {
        let position = 1;
        const container = jQuery('#timeline-events');
        const scrollDuration = 500;
        const lastAnchorPos = jQuery('.last-anchor').position().left
        const widthLeaders = jQuery("#timeline-dirigeants").width();

        jQuery('.line-style').css('width', lastAnchorPos + widthLeaders - 20)

        jQuery('#next-timeline').on('click', function() {
            position = position + 2
            scrollToAnchor("#pos-" + position)
        })
        jQuery('#prev-timeline').on('click', function() {
            position = position - 2
            scrollToAnchor("#pos-" + position)
        })

        const scrollToAnchor = (anchorId) => {
            const anchorElement = jQuery(anchorId);
            if (anchorElement.length) {
                const targetScrollLeft = anchorElement.position().left;
                const containerWidth = container.width()

                if (targetScrollLeft == 0) {
                    jQuery('.svg-prev').removeClass('fill-orange').addClass('fill-primary')
                } else {
                    jQuery('.svg-prev').addClass('fill-orange').removeClass('fill-primary')
                }
                if (targetScrollLeft + 300 >= containerWidth) {
                    jQuery('.svg-next').removeClass('fill-orange').addClass('fill-primary')
                } else {
                    jQuery('.svg-next').addClass('fill-orange').removeClass('fill-primary')
                }
    
                container.animate({ scrollLeft:  targetScrollLeft }, scrollDuration);
            }
        };
    }
    
    if (jQuery("#timeline-events").length != 0) {
        timeline_evolution();
    }


    if (jQuery('#other-realisations').length != 0) {
        let sliderOtherRealisations = tns({
            container: "#slider-other-realisations",
            items: 1,
            loop: false,
            mouseDrag: true,
            nav: false,
            swipeAngle: false,
            responsive: {
                768: {
                    items: 2
                },
                1280: {
                    items: 4
                }
            },
            controlsContainer: "#controlers-slider-other-realisations",
        })
    }
    
    console.log('main.js');
});

